import type { CareersContent } from "../types";

/** 加入我们：大字招聘横幅（三家公司页共有的 careers CTA 模块） */
export function renderCareers(careers: CareersContent): string {
  return `
    <section class="section careers-section" id="${careers.id}">
      <div class="careers" data-reveal>
        <h2>${careers.title}</h2>
        <p>${careers.intro}</p>
        <a href="${careers.cta.href}" class="btn careers-btn">${careers.cta.label}</a>
      </div>
    </section>`;
}
